import { NgIf } from '@angular/common';
import { Directive, Input, inject } from '@angular/core';
import { ISites } from '@df/core/df-core.interfaces';
import { MultisiteService } from '@df/core/service/multisite';

/**
 * Directive to check if current store is one of passed
 *
 * ```html
 * <div *ifStore="'uk'"></div>
 * <div *ifStore="'!uk'"></div>
 * <div *ifStore="['uk', 'us']"></div>
 * ```
 *
 */
// @Directive({ selector: '[ifStore]' })
@Directive()
export class IfStoreDirectiveDef extends NgIf {
    private multisiteService = inject(MultisiteService);

    @Input()
    set ifStore(store: string | keyof ISites[]) {
        if (Array.isArray(store)) {
            this.ngIf = store.includes(<string>this.multisiteService.siteId);
        } else if (typeof store === 'string') {
            const invert = store[0] === '!';
            if (invert) {
                store = store.substr(1);
            }
            const stores = store.split(',').map(i => i.trim());
            this.ngIf = stores.includes(<string>this.multisiteService.siteId) ? !invert : invert;
        } else {
            this.ngIf = false;
        }
    }
}
